import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BRAND = {
  hpmi: { color: '#002157', accent: '#C89B3C', tagline: 'EXCELLENCE • CARE • INTEGRITY', logo: '/hpmi-logo.webp' },
  montessori: { color: '#14532D', accent: '#D97706', tagline: 'NURTURE • LEARN • GROW', logo: null },
};

export default function WelcomeLetter() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/welcome/${token}`).then((r) => setD(r.data)).catch((e) => setErr(e.response?.data?.detail || 'Unable to load welcome letter.'));
  }, [token]);

  if (err) return <div className="flex min-h-screen items-center justify-center p-6 text-center text-sm text-[#B91C1C]" data-testid="welcome-error">{err}</div>;
  if (!d) return <div className="flex min-h-screen items-center justify-center text-sm text-[#94A3B8]">Loading…</div>;

  const b = BRAND[d.school_key] || BRAND.hpmi;
  const dateStr = d.date ? new Date(`${d.date}T00:00:00`).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' }) : new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
  const salutation = d.parent_name ? `Dear Mr./Mrs. ${d.parent_name},` : 'Dear Parent / Guardian,';

  return (
    <div className="min-h-screen bg-[#F5F7FB] p-4 sm:p-8" data-testid="welcome-letter-page">
      <div className="mx-auto mb-4 max-w-3xl print:hidden">
        <button data-testid="welcome-print-btn" onClick={() => window.print()} className="w-full rounded-lg bg-navy py-2.5 text-sm font-semibold text-white sm:w-auto sm:px-8">Print / Save as PDF</button>
      </div>
      <div className="welcome-sheet mx-auto max-w-3xl rounded-xl bg-white p-6 shadow-sm sm:p-10 print:rounded-none print:p-0 print:shadow-none" data-testid="welcome-letter-sheet">
        <div className="flex items-center gap-4 border-b-2 pb-4" style={{ borderColor: b.accent }}>
          {b.logo && <img src={b.logo} alt={d.school_name} className="h-16 w-16" data-testid="welcome-school-logo" />}
          <div className={b.logo ? '' : 'w-full text-center'}>
            <p className="font-heading text-xl font-bold sm:text-2xl" style={{ color: b.color }} data-testid="welcome-school-name">{d.school_name}</p>
            <p className="text-[10px] font-semibold uppercase tracking-[0.2em]" style={{ color: b.accent }}>{b.tagline}</p>
          </div>
        </div>
        <p className="mt-6 text-center text-sm font-bold uppercase tracking-widest" style={{ color: b.color }} data-testid="welcome-letter-title">{d.title}</p>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-[#334155] sm:text-[15px]">
          <p className="text-right text-xs text-[#64748B]" data-testid="welcome-letter-date">Date: {dateStr}</p>
          {d.address && (
            <div className="text-xs text-[#475569]" data-testid="welcome-letter-address">
              <p className="font-semibold">{d.parent_name || 'Parent / Guardian'}</p>
              <p className="whitespace-pre-line">{d.address}</p>
            </div>
          )}
          <p data-testid="welcome-salutation">{salutation}</p>
          <p data-testid="welcome-body-1">We are delighted to welcome <strong>{d.applicant_name}</strong> to <strong>{d.school_name}</strong>.</p>
          <p data-testid="welcome-body-2">We are pleased to inform you that <strong>{d.applicant_name}</strong> has been admitted to <strong>{d.class_name}</strong> for the academic session <strong>{d.session}</strong>.{d.form_number ? <> The admission form number is <strong>{d.form_number}</strong>.</> : null}</p>
          <p>The student's admission details and further instructions will be communicated to you through the Admission Hub.</p>
          <p>We look forward to welcoming <strong>{d.applicant_name}</strong> to our school community.</p>
          <div className="pt-6">
            <p>Warm regards,</p>
            <p className="mt-1 font-semibold" style={{ color: b.color }} data-testid="welcome-signoff">Management<br />{d.school_name}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
